import { removeHtmlCode } from '../../../shared/mixin';

var React                         = require("react");
var _                             = require('lodash');

var ChallengeCardDetails          = require("./challenge_card_details");
var ChallengeCardPoints           = require("./challenge_card_points");
var ChallengeCardStatusList       = require("./challenge_card_status_list");
var ChallengeCard                 = require("./challenge_card");
var CardRatioContainer            = require("./card_ratio_container");
var ChallengeCardUnlocked         = require("./challenge_card_unlocked");
var { withNamespaces } = require('react-i18next');
var cn = require('classnames');

const defaultImage = "https://images.influitive.com/cdn-cgi/imagedelivery/pKRqk_cgZfGOj9FgBNYyVA/generic_challenge_banner/public";

var ShortCard = ({ challenge, shortCardDesignEnabled, retrieveChallengeStatusDescription, challengeStatusDescription, handleViewClick, rewriteLook }) => (
  <a onClick={handleViewClick} className="card__link card__text-wrapper">
    {rewriteLook
      ? <ChallengeCardDetails.Label label={challenge.type} shortCardDesignEnabled={shortCardDesignEnabled} rewriteLook={rewriteLook} />
      : null}
    <ChallengeCardDetails>
      <ChallengeCardDetails.Headline headline={removeHtmlCode(challenge.headline)} shortCardDesignEnabled={shortCardDesignEnabled} />
    </ChallengeCardDetails>
    <div className={cn({"card__bottom-section card__content-border": true, "card__content-border__rewrite": rewriteLook })}>
      {rewriteLook
        ? null
        : <ChallengeCardDetails.Label label={challenge.type} shortCardDesignEnabled={shortCardDesignEnabled} rewriteLook={rewriteLook} />}
      <div className={cn({"card__bottom-right-section": true, "card__bottom-right-section__rewrite": rewriteLook})}>
        {rewriteLook
          ? <ChallengeCardPoints points={challenge.points} shortCardDesignEnabled={shortCardDesignEnabled} rewriteLook={rewriteLook} />
          : null}
        <ChallengeCardStatusList
          challenge={challenge}
          retrieveChallengeStatusDescription={retrieveChallengeStatusDescription}
          challengeStatusDescription={challengeStatusDescription}
          rewriteLook={rewriteLook} />
        {rewriteLook
          ? null
          : <ChallengeCardPoints points={challenge.points} shortCardDesignEnabled={shortCardDesignEnabled} rewriteLook={rewriteLook} />}
      </div>
    </div>
  </a>
);

var LongCard = ({ challenge, shortCardDesignEnabled, retrieveChallengeStatusDescription, challengeStatusDescription, handleViewClick }) => (
  <a onClick={handleViewClick} className="card__link card__text-wrapper">
    <ChallengeCardDetails>
      <ChallengeCardDetails.Label label={challenge.type} shortCardDesignEnabled={shortCardDesignEnabled} />
      <ChallengeCardDetails.Headline headline={removeHtmlCode(challenge.headline)} shortCardDesignEnabled={shortCardDesignEnabled} />
      <ChallengeCardDetails.Description description={_.escape(challenge.description)} />
    </ChallengeCardDetails>
    <div className="card__bottom-section">
      <ChallengeCardStatusList
        challenge={challenge}
        retrieveChallengeStatusDescription={retrieveChallengeStatusDescription}
        challengeStatusDescription={challengeStatusDescription} />
      <ChallengeCardPoints points={challenge.points} shortCardDesignEnabled={shortCardDesignEnabled} />
    </div>
  </a>
);


var ChallengeCardContainer = React.createClass({
  PropTypes: {
    challenge: React.PropTypes.object,
    challengeActions: React.PropTypes.object,
    challengeStage : React.PropTypes.string.isRequired,
    retrieveChallengeStatusDescription : React.PropTypes.func.isRequired,
    challengeStatusDescription : React.PropTypes.object.isRequired,
    c2cfLabel : React.PropTypes.string,
    shortCardDesignEnabled: React.PropTypes.bool,
    isUnlockable: React.PropTypes.bool,
    rewriteLook: React.PropTypes.bool,
  },

  getDefaultProps: function() {
    return {
      challenge: {},
      challengeActions: {},
      challengeStage: "",
      challengeStatusDescription: {
        challengeId : "",
        statusDescription : "",
        status: ""
      },
      c2cfLabel: ""
    }
  },

  getInitialState : function () {
    return {
      isOptionsOpen : false
    };
  },

  componentDidMount: function() {
     this.props.c2cfLabel && app.analytics.logC2CFEvent(this.props.c2cfLabel)
  },

  render: function() {
    const handleViewClick = !this.props.isUnlockable && this._handleViewClick;

    return (
      <ChallengeCard
          key={this.props.challenge.id}
          id={"challenge-" + this.props.challenge.id}
          rewriteLook={this.props.rewriteLook}>
        {this._wasChallengeCardUnlocked()}

        <CardRatioContainer shortCardDesignEnabled={this.props.shortCardDesignEnabled}>
          {this.props.challenge.unseen && <div className='card__unseen_label'>{this.props.t('New')}</div>}
          <div className={cn('card__wrapper', this.props.isUnlockable && 'card__grayed')}>
            <a onClick={handleViewClick} className="card__link" aria-label={removeHtmlCode(this.props.challenge.headline)}>
              <ChallengeCard.Image image={this._determineChallengeImage()} rewriteLook={this.props.rewriteLook} />
            </a>
            <div className="card__content card__content-border">
                {this.props.shortCardDesignEnabled
                  ? <ShortCard handleViewClick={handleViewClick} {...this.props} />
                  : <LongCard handleViewClick={handleViewClick} {...this.props} />
                }
                {this.props.rewriteLook
                  ? <ChallengeCard.Options
                    isOpen={this.state.isOptionsOpen}
                    handleToggle={this._handleOptionsToggle}
                    rewriteLook={this.props.rewriteLook}>
                    <a href="#" onClick={this._handleLaterClick}>{this.props.t('Save for later')}</a>
                  </ChallengeCard.Options>
                  : null}
            </div>
          </div>
        </CardRatioContainer>
      </ChallengeCard>
    );
  },

  _wasChallengeCardUnlocked: function(){
    if(this.props.challenge.unlocked) {
      return <ChallengeCardUnlocked />;
    }

    return null;
  },

  _determineChallengeImage : function(){
    return this.props.challenge.image
      ? this.props.challenge.image
      : this.props.rewriteLook
      ? null
      : defaultImage;
  },

  _challengeActionsConfig : function(){
    return {
      view: this._handleViewClick,
      later: this._handleLaterClick
    }
  },

  _handleViewClick: function(event) {
    this._handleClick(event, 'view_button');
  },

  _handleLaterClick: function(event) {
    event.preventDefault();
    event.stopPropagation();
    this._setToggle(false);
    this.props.challengeActions.later(this.props.challenge);
  },

  _handleImageClick: function(event) {
    this._handleClick(event, 'image');
  },

  _handleHeadlineClick: function(event) {
    this._handleClick(event, 'headline');
  },

  _handleClick: function(event, source) {
    const { challenge, challengeActions } = this.props;

    event.preventDefault();
    event.stopPropagation();
    mobile.iosInflunet.startOpeningChallenge();
    challenge.unseen && challengeActions.markAsSeen(challenge.id);
    challengeActions.view(challenge, source, this.props.challengeStage);
  },

  _setToggle: function(bool) {
    this.setState({ isOptionsOpen: bool });
  },

  _handleOptionsToggle: function() {
    this._setToggle(!this.state.isOptionsOpen);
  }
});

module.exports = withNamespaces()(ChallengeCardContainer);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_card_container.jsx